import { HomePageDataContext } from '@/contexts/HomePageDataContext';
import { useContext } from 'react';

export const useHomeData = () => {
  const context = useContext(HomePageDataContext);
  if (!context) {
    throw new Error('useHomeData deve ser utilizado HomePageDataContext');
  }
  return context;
};
